angular.module('qkr').controller('questController', ($scope, questService) => {
    $scope.checkForChanges = function() {
        $scope.anyChanges = false;
        for (let i = 0; i < $scope.syncData.syncedItems.length; ++i) {
            const item = $scope.syncData.syncedItems[i];
            if (item.originalStockId != item.stockId) {
                $scope.anyChanges = true;
            }
        }
    };

    $scope.initQuest = function() {
        console.log('initQuest called');
        $scope.syncing = true;
        questService.getQuestSyncData().then((data) => {
                $scope.syncData = data;
                $scope.setOriginalValues($scope.syncData.syncedItems);
                $scope.anyChanges = false;
                $scope.syncing = false;
            }
        );
    };

    $scope.setOriginalValues = function(items) {
        if (items) {
            for (let i = 0; i < items.length; ++i) {
                const item = items[i];
                item.originalStockId = item.stockId;
            }
        } else {
            console.log('setOriginalValues: called with null');
        }
    };

    $scope.update = function() {
        console.log('update called');

        const changes = [];
        for (let i = 0; i < $scope.syncData.syncedItems.length; ++i) {
            const item = $scope.syncData.syncedItems[i];
            if (item.originalStockId != item.stockId) {
                changes.push({id: item.qkrId, stockId: item.stockId});
            }
        }

        questService.updateQuestData(changes).then((promise) => {
                $scope.syncData = promise.data;
                console.log('Got response from update', promise);
                $scope.setOriginalValues($scope.syncData.syncedItems);
                $scope.anyChanges = false;
                $scope.syncing = false;
            }
        );
    };
});



// WEBPACK FOOTER //
// ./src/controllers/quest.controller.js